import { IconProps } from '@models/icons';

function LeftIcon({ size, color, ...rest }:IconProps) {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest}>
            <path d="M6.3002 4.2L2.70019 9L6.3002 13.8" stroke="#AFA8A5" strokeWidth="1.4" strokeLinecap="round"
                strokeLinejoin="round"/>
        </svg>);
}

export default LeftIcon;
